import BlockUtilsMixin from '@intercom/embercom-composer/components/mixins/block-utils';
import { normalizeEvent } from '@intercom/embercom-composer/lib/normalize-event';
import $ from 'jquery';
import { bind, cancel, next, throttle } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create(BlockUtilsMixin, {
  isSelecting: false,
  setupMouseEventHandlers: Em.on('didInsertElement', function () {
    let elementId = this.get('elementId');
    $(document).on(`mousedown.${elementId}`, bind(this, this.mouseDownOutside));
    $(document).on(`mouseup.${elementId}`, bind(this, this.mouseUpOutside));
    $(document).on(`mousemove.${elementId}`, bind(this, this.mouseMove));
    $('body').on(`drop.${elementId}`, function (e) {
      e.preventDefault();
    });
    $('body').on(`dragover.${elementId}`, function (e) {
      e.preventDefault();
    });
  }),
  destroyMouseEventHandlers: Em.on('willDestroyElement', function () {
    let elementId = this.get('elementId');
    $(document).off(`mousedown.${elementId}`);
    $(document).off(`mouseup.${elementId}`);
    $(document).off(`mousemove.${elementId}`);
    $('body').off(`dragover.${elementId}`);
    $('body').off(`drop.${elementId}`);
    cancel(this.get('mouseMoveThrottle'));
  }),
  touchStart() {
    try {
      this.syncCurrentBlock();
    } catch (error) {
      this.sendError(error);
    }
  },
  contextMenu(event) {
    if (/Firefox/.test(navigator.userAgent)) {
      let nativeEvent = normalizeEvent(event);
      if (nativeEvent && nativeEvent.target && nativeEvent.target === this.get('$editor')[0]) {
        // Prevent right click from putting caret inside blocks
        this.get('uiSelection.domSelection').clear();
      }
    }
    this.set('_didOpenContextMenu', true);
  },
  mouseDown(e) {
    this.setLastActiveBlockAndSelection();
    let target = e.target;
    let $target = $(target);
    try {
      this._handleContextMenuSelection();
      this.syncCurrentBlock();
      this.clearBlockSelection();
      let clickedAttribute = $target.closest('ic-attribute');
      if (clickedAttribute.length > 0) {
        this._selectClickedAttribute(clickedAttribute);
        e.preventDefault();
        return;
      }
      if (this._isLeftClick(e)) {
        this.set('isSelecting', true);
      } else {
        return;
      }
      if (this._isParagraphInserter(target)) {
        this.insertParagraphAtHoveredIndex();
        e.preventDefault();
        return;
      }
      if (this._isIcBlock(target)) {
        this._selectBlock($target.closest('ic-block'));
        e.preventDefault();
        return;
      }
    } catch (error) {
      this.sendError(error);
    }
  },
  mouseDownOutside(e) {
    if (this.get('$editor') && this._mouseEventIsOutsideComposer(e)) {
      this.syncLastActiveBlock();
    }
  },
  mouseUpOutside(e) {
    if (this.get('$editor') && (this._mouseEventIsOutsideComposer(e) || this.get('isSelecting'))) {
      this.setSelectionCoordinates();
      this.setTextBeforeCursor();
      this.syncLastActiveBlock();
      if (this.get('isSelecting')) {
        this.syncCurrentBlock();
      } else {
        this.syncCurrentBlockWithoutSelectionUpdate();
      }
      this.set('isSelecting', false);
    }
  },
  click(e) {
    let $target = $(e.target);
    if (this._isImageRetry($target)) {
      this.get('composerState').getBlockById($target.data('block-id')).retryUpload();
      e.preventDefault();
    } else if (this._isVideoFileControl($target)) {
      this._handleVideoFileControlsClick($target);
      e.preventDefault();
    }
  },
  mouseUp(e) {
    this.setLastActiveBlockAndSelection();
    this.set('isSelecting', false);
    this.setTextBeforeCursor();
    try {
      this.setSelectionCoordinates();
      let domSelection = this.get('uiSelection.domSelection');
      if (domSelection.isZeroWidthSpaceSelection()) {
        domSelection.collapseToStart();
      }
      if (this.isCurrentBlockAnICBlock()) {
        this.get('uiSelection').clearDomSelection();
      }
    } catch (error) {
      this.sendError(error);
    }
    next(this, function () {
      if ($(e.target).closest('ic-block').length === 0) {
        this.syncCurrentBlock();
      }
    });
  },
  mouseMove(e) {
    if (!this.get('disableHoveredBlockUpdates')) {
      let mouseMoveThrottle = throttle(this, this._handleMouseMove, e, 32, false);
      this.set('mouseMoveThrottle', mouseMoveThrottle);
    }
  },
  _handleMouseMove(event) {
    try {
      if (!this.isDestroying) {
        let nativeEvent = normalizeEvent(event);
        this.set('isTyping', false);
        this.setHoverCoordinates(nativeEvent.clientX, nativeEvent.clientY);
      }
    } catch (error) {
      this.sendError(error);
    }
  },
  dragOver(event) {
    try {
      let nativeEvent = normalizeEvent(event);
      this._handleContextMenuSelection();
      this.setHoverCoordinates(nativeEvent.clientX, nativeEvent.clientY);
      if (this.get('isDragAndDropEnabled')) {
        nativeEvent.dataTransfer.dropEffect = 'copy';
      } else {
        nativeEvent.preventDefault();
        nativeEvent.dataTransfer.dropEffect = 'none';
      }
    } catch (error) {
      this.sendError(error);
    }
  },
  drop(e) {
    try {
      this._handleContextMenuSelection();
      e.preventDefault();
      if (this.get('isDragAndDropEnabled')) {
        let filesArray = [];
        let files = e.dataTransfer.files;
        for (let i = 0, length = files.length; i < length; i++) {
          filesArray.push(files[i]);
        }
        this.fileDrop(filesArray);
      }
    } catch (error) {
      this.sendError(error);
    }
  },
  _isLeftClick(e) {
    if (e.button === undefined) {
      return true;
    }
    return e.button === 0;
  },
  _isParagraphInserter(node) {
    return node.tagName === 'INSERT-POINT';
  },
  _isIcBlock(node) {
    return node.tagName === 'IC-BLOCK' || $(node).closest('ic-block').length !== 0;
  },
  _isImageRetry($node) {
    return $node.hasClass('composer-upload-retry');
  },
  _isVideoFileControl($node) {
    return $node.hasClass('block-video-file-control');
  },
  _selectClickedAttribute(attribute) {
    let entityId = $(attribute).data('id');
    this.get('composerState').setSelectionByEntityId(entityId);
    this.get('uiSelection').clearDomSelection();
  },
  _handleVideoFileControlsClick($node) {
    let video = $node.siblings('video').get(0);
    if ($node.hasClass('block-video-file-play-control')) {
      $node.toggleClass('paused');
      video.paused ? this._handleVideoPlayButtonClicked($node) : video.pause();
    }
    if ($node.hasClass('block-video-file-audio-control')) {
      if (!$node.hasClass('replay')) {
        $node.toggleClass('muted');
        video.muted = !video.muted;
      }
      this._handleVideoPlayButtonClicked($node);
    }
  },
  _handleVideoPlayButtonClicked($node) {
    let videoFileBlock = $node.parents('ic-block');
    this.get('composerState').getBlockById(videoFileBlock.data('id')).videoPlayed();
  },
  _selectBlock($block) {
    let selection = this.get('uiSelection.domSelection').getSelectionOfBlock($block);
    let selectionIsValid = selection.startBlockIndex >= 0 && selection.endBlockIndex >= 0;
    if (selectionIsValid) {
      this.clearBlockSelection();
      this.get('composerState').setSelection(selection.startBlockIndex, selection.startItemIndex, selection.startPositionIndex, selection.endBlockIndex, selection.endItemIndex, selection.endPositionIndex);
      this.updateDomAndSelection();
    }
  },
  _handleContextMenuSelection() {
    if (this.get('_didOpenContextMenu')) {
      this.set('_didOpenContextMenu', false);
      if (window.getSelection().anchorNode && window.getSelection().anchorNode.isEqualNode($('.embercom-composer-editor')[0])) {
        this.selectAll();
      }
    }
  },
  _mouseEventIsOutsideComposer(e) {
    let $editor = this.get('$editor');
    let isEditor = $editor[0] === e.target;
    if (isEditor) {
      return false;
    }
    let isInsideEditor = $editor.has(e.target).length > 0;
    if (isInsideEditor) {
      return false;
    }
    let isInTemplateContainer = $editor.closest('.composer-template-container').has(e.target).length > 0;
    if (isInTemplateContainer) {
      return true;
    }
    let $composer = $editor.closest('.embercom-composer');
    let isInsideDebugContainer = $composer.find('#composer-debug-container').has(e.target).length > 0;
    if (isInsideDebugContainer) {
      return true;
    }
    let $target = $(e.target);
    let isNotInsideComponent = $composer.has(e.target).length === 0;
    let targetId = $target.data('id');
    let isNotBOMFromThisComposer = !targetId || $editor.find(`[data-id="${targetId}"]`) === 0;
    let isNotAttribute = !$target.parent().is('ic-attribute');
    return isNotInsideComponent && isNotBOMFromThisComposer && isNotAttribute;
  }
});